import React from 'react';
import styled from 'styled-components';
import CalendarSection from '../comp/CalendarSection';
import BalanceSection from '../comp/BalanceSection';

const ChartsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; // Two equal columns
  gap: 30px;

  @media (max-width: 992px) {
    // Stack charts below 992px
    grid-template-columns: 1fr;
  }
`;

const ChartsSection3 = ({ data, receivableDates, onDoubleClick }) => {
  return (
    <ChartsContainer>
      <BalanceSection data={data}/>
      <CalendarSection title={'Próximos Recebimentos'} receivableDates={receivableDates} onDoubleClick={onDoubleClick}/>
    </ChartsContainer>
  );
};

export default ChartsSection3;
